import { FC } from "react"
import { LogRegModal } from "./LogRegModal"
import { SuccessModal } from "./SuccessModal"
import { FormModalProps } from "../Header/Header"

export const FormModal:FC<FormModalProps> =( {logRegModal, setLogRegModal, successModal, setSuccessModal})=>{

    return (
        <>
        <LogRegModal logRegModal={logRegModal} setLogRegModal={setLogRegModal} successModal={successModal} setSuccessModal={setSuccessModal} />
        <SuccessModal logRegModal={logRegModal} setLogRegModal={setLogRegModal} successModal={successModal} setSuccessModal={setSuccessModal}/>
        </>
    )
}